import React from "react";
import {Card, ProgressBar} from "react-bootstrap";

function StatsWid(props) {

    return (
        <Card className={props.classdata}>
            <Card.Body style={{paddingLeft:"20px", paddingRight:"50px", paddingTop:"30px", paddingBottom:"40px"}}>
                <Card.Title>{props.data.title}</Card.Title>
                <smal>{props.data.subtitle}</smal>
                <br></br>
                <ProgressBar style={{marginTop:"50px"}}>
                    <ProgressBar  variant={props.data.variant} now={props.data.actualValue} label={props.data.actualValue} />
                    <ProgressBar style={{opacity:"0.3"}} variant="danger" now={props.threshold-props.data.actualValue}/>
                </ProgressBar>
            </Card.Body>
        </Card>
    );
  }
  
  export default StatsWid;